import { useEffect, useState } from "react";
import Page from "../../components/Page";
import { useDispatch, useSelector } from "react-redux";
import {
  changeDueDateAssignUser,
  changeDueDateAssignUserResClear,
  getAssignUsersList,
  getAssignUsersListResClear,
} from "../../redux/assignCourse/actions";
import { SessionKeys } from "../../utils/AppUtils";
import moment from "moment";
import _, { template } from "lodash";
import Loader from "../../components/Loader/Loader";
import { Tab, Tabs } from "react-bootstrap";
import BackButton from "../../components/Layouts/BackButton";
import { useNavigate } from "react-router-dom";
import {
  getMyTeamListReq,
  getMyTeamListReqResponseClear,
  impersonateUser,
  impersonateUserResponseClear,
  setUserRole,
  userDetailBroker,
} from "../../redux/user/actions";
import { loginBrokerResponse } from "../../redux/auth/actions";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { getActiveHeader } from "../../redux/home/actions";

const MyTeamListPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);

  const isMobile = params.get("isMobile");

  const myTeamsListRes = useSelector((state) => state.user.myTeamsListRes);
  const impersonateRes = useSelector((state) => state.user.impersonateUserData);

  const [isLoading, setIsLoading] = useState(false);
  const [myTeamsList, setMyTeamsList] = useState([]);
  const [myTeamsListFilter, setMyTeamsListFilter] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedSort, setSelectedSort] = useState("");

  const [confirmModal, setConfirmModal] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");

  useEffect(() => {
    dispatch(getActiveHeader(""));
    getMyTeamsList();
  }, []);

  useEffect(() => {
    console.log("myTeamsListRes: ", myTeamsListRes);
    if (!_.isEmpty(myTeamsListRes)) {
      setIsLoading(false);
      window.scrollTo(0, 0);
      if (myTeamsListRes?.status === "success") {
        setMyTeamsList(myTeamsListRes?.payload?.payload);
        setMyTeamsListFilter(myTeamsListRes?.payload?.payload);
        setSelectedSort("name");
        dispatch(getMyTeamListReqResponseClear());
      } else {
        setMyTeamsList([]);
        setMyTeamsListFilter([]);
      }
    }
  }, [myTeamsListRes]);

  //get leader board
  const getMyTeamsList = () => {
    setIsLoading(true);
    dispatch(
      getMyTeamListReq({
        module: "myTeamListReq",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        },
      })
    );
  };

  useEffect(() => {
    let timerId = null;
    if (_.isEmpty(searchValue)) {
      //   setIsLoading(true);
      setMyTeamsList(myTeamsListFilter);
      //   getCoachNotesDataReq();
    } else {
      timerId = setTimeout(() => {
        // getCoachNotesDataReq();
        let tempList = [];
        for (let i = 0; i < myTeamsListFilter.length; i++) {
          const element = myTeamsListFilter[i];
          let name = element.first_name + " " + element.last_name;
          if (
            name?.toLowerCase().includes(searchValue?.toLowerCase()) ||
            element.email?.toLowerCase().includes(searchValue?.toLowerCase())
          ) {
            tempList.push(element);
          }
        }
        setMyTeamsList(tempList);
      }, 700);
    }
    return () => {
      clearTimeout(timerId);
    };
  }, [searchValue]);

  useEffect(() => {
    console.log("selectedSort: ", selectedSort, myTeamsList);
    if (!_.isEmpty(selectedSort) && !_.isEmpty(myTeamsList)) {
      let tempList = [];
      tempList = _.cloneDeep(myTeamsList);
      if (selectedSort === "name") {
        tempList.sort((a, b) => {
          const nameA =
            a.first_name.toUpperCase() + " " + a.last_name?.toUpperCase(); // ignore upper and lowercase
          const nameB =
            b.first_name.toUpperCase() + " " + b.last_name?.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      if (selectedSort === "nameRev") {
        tempList.sort((a, b) => {
          const nameA =
            a.first_name.toUpperCase() + " " + a.last_name?.toUpperCase();
          const nameB =
            b.first_name.toUpperCase() + " " + b.last_name?.toUpperCase();
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      if (selectedSort === "email") {
        tempList.sort((a, b) => {
          const nameA = a.email.toUpperCase(); // ignore upper and lowercase
          const nameB = b.email.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      if (selectedSort === "emailRev") {
        tempList.sort((a, b) => {
          const nameA = a.email.toUpperCase(); // ignore upper and lowercase
          const nameB = b.email.toUpperCase(); // ignore upper and lowercase
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      if (selectedSort === "role") {
        tempList.sort((a, b) => {
          const nameA = a.Role.toUpperCase(); // ignore upper and lowercase
          const nameB = b.Role.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      if (selectedSort === "roleRev") {
        tempList.sort((a, b) => {
          const nameA = a.Role.toUpperCase(); // ignore upper and lowercase
          const nameB = b.Role.toUpperCase(); // ignore upper and lowercase
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      } else if (selectedSort === "office") {
        tempList.sort((a, b) => {
          const nameA = a.office_name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.office_name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      } else if (selectedSort === "officeRev") {
        tempList.sort((a, b) => {
          const nameA = a.office_name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.office_name.toUpperCase(); // ignore upper and lowercase
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      setMyTeamsList(tempList);
    }
  }, [selectedSort]);

  const [impersonateAPICalled, setimpersonateAPICalled] = useState(false);
  const [selectedID, setSelectedID] = useState("");

  const initCase = (name) => {
    return _.capitalize(_.toLower(name));
  };

  const callImpersonateAPI = (item) => {
    setSelectedID(item?.id);
    setShowModalMsg(
      `You are impersonating into the account of ${initCase(item?.first_name)} ${initCase(
        item?.last_name
      )}, please do not make any changes to the account.`
    );
    setIsConfirm(true);
    setConfirmModal(true);
  };

  const confirmAction = () => {
    setimpersonateAPICalled(true);
    setIsLoading(true);
    dispatch(
      impersonateUser({
        module: "impersonate-user",
        postData: {
          user_id: selectedID,
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          action: "start_imp"
        },
      })
    );
  };

  useEffect(() => {
    if (!_.isEmpty(impersonateRes) && impersonateAPICalled) {
      console.log("check--", impersonateRes);
      if (impersonateRes?.status === "success") {
        let userData = impersonateRes?.payload?.payload?.user_data;
        localStorage.setItem(SessionKeys.IS_IMPERSONATED, true);
        localStorage.setItem(
          SessionKeys.LOGGED_IN_USER_TOKEN,
          localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
        );
        localStorage.setItem(
          SessionKeys.LOGGED_IN_USER_ID,
          localStorage.getItem(SessionKeys.USER_ID)
        );
        localStorage.setItem(
          SessionKeys.API_TOKEN_BROKER,
          impersonateRes?.payload?.payload?.token
        );
        localStorage.setItem(SessionKeys.USER_ID, userData?.user_id);
        localStorage.setItem(SessionKeys.FIRST_NAME, userData?.firstname);
        dispatch(
          userDetailBroker({
            module: "getOrderDetailBroker",
            apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          })
        )
        if (_.isArray(userData?.role)) {
          // console.log("USER ROLE", roleArray);

          if (userData?.role.includes("customer")) {
            dispatch(setUserRole("customer"));
          } else if (userData?.role.includes("realtor")) {
            dispatch(setUserRole("realtor"));
          } else if (userData?.role.includes("manager")) {
            dispatch(setUserRole("manager"));
          } else if (userData?.role.includes("pmpro_membership_manager")) {
            // console.log("USER ROLE PMPRO", roleArray);
            dispatch(setUserRole("broker"));
          } else if (userData?.role.includes("instructor")) {
            dispatch(setUserRole("instructor"));
          } else if (userData?.role.includes("host")) {
            dispatch(setUserRole("host"));
          } else if (userData?.role.includes("broker_admin")) {
            dispatch(setUserRole("admin"));
          }
        }
        dispatch(
          loginBrokerResponse({
            payload: {
              user: {
                user_id: userData?.user_id,
                username: userData?.username,
                firstname: userData?.firstname,
                middlename: userData?.middlename,
                lastname: userData?.lastname,
                email: userData?.email,
                bot_token: userData?.bot_token,
                ai_roleplay_token: userData?.ai_roleplay_token,
                profile_img: userData?.profile_img,
                isProfileCompleted: userData?.isProfileCompleted,
                isOnboarding: userData?.isOnboarding,
                isPremium: userData?.isPremium,
                profile_img_check: userData?.profile_img_check,
                city: userData?.city,
                state: userData?.state,
                designation: userData?.designation,
                timezone: userData?.timezone,
                timezoneAbbr: userData?.timezoneAbbr,
                profile_complete: userData?.profile_complete,
                broker_id: userData?.broker_id,
                broker_name: userData?.broker_name,
                zoom_id: userData?.zoom_id,
                company_id: userData?.company_id,
                role: userData?.role,
                IsGuest: userData?.IsGuest,
                ip_address: userData?.ip_address,
                broker_of_records: userData?.broker_of_records,
                isagreed: userData?.isagreed,
                complete_tour: userData?.complete_tour,
                guest_end_date: userData?.guest_end_date,
                display_subscription_menu: userData?.display_subscription_menu,
                is_parent: userData?.is_parent,
                parent_name: userData?.parent_name,
                branding: userData?.branding,
                apply_theme: userData?.apply_theme,
                branding_primary_color_1: userData?.branding_primary_color_1,
                branding_primary_color_2: userData?.branding_primary_color_2,
                branding_company_logo: userData?.branding_company_logo,
                is_google_sso_enabled: userData?.is_google_sso_enabled,
                is_ms_sso_enabled: userData?.is_ms_sso_enabled,
                is_sso_enabled: userData?.is_sso_enabled,
                partner_menu: userData?.partner_menu,
                courseURL: userData?.courseURL,
              },
              apiToken: impersonateRes?.payload?.payload?.token,
            },
          })
        );
        // getMyTeamsList();
        navigate("/home");
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      } else {
      }
      setimpersonateAPICalled(false);
    }
    // return () => {
    //   dispatch(impersonateUserResponseClear());
    // };
  }, [impersonateRes]);

  const renderTableReport = () => {
    return (
      <>
        <div className="row my-team-table">
          <div className="col-lg-12 col-md-12">
            <div className="course-info-table">
              {myTeamsList.length > 0 ? (
                <table className="table mb-0 office_list table-striped">
                  <thead>
                    <tr>
                      <th
                        className={`cursor-pointer is-sort ${
                          selectedSort === "name" && "selected-sort"
                        }`}
                        onClick={() => {
                          if (selectedSort === "name") {
                            setSelectedSort("nameRev");
                          } else setSelectedSort("name");
                        }}
                        style={{ minWidth: "300px" }}
                      >
                        Name
                      </th>
                      <th
                        className={`cursor-pointer is-sort ${
                          selectedSort === "email" && "selected-sort"
                        }`}
                        onClick={() => {
                          if (selectedSort === "email") {
                            setSelectedSort("emailRev");
                          } else setSelectedSort("email");
                        }}
                        style={{ minWidth: "300px" }}
                      >
                        Email
                      </th>
                      <th
                        className={`cursor-pointer is-sort ${
                          selectedSort === "role" && "selected-sort"
                        }`}
                        onClick={() => {
                          if (selectedSort === "role") {
                            setSelectedSort("roleRev");
                          } else setSelectedSort("role");
                        }}
                        style={{ width: "auto" }}
                      >
                        Role
                      </th>
                      <th
                        className={`cursor-pointer is-sort ${
                          selectedSort === "office" && "selected-sort"
                        }`}
                        onClick={() => {
                          if (selectedSort === "office") {
                            setSelectedSort("officeRev");
                          } else setSelectedSort("office");
                        }}
                        style={{ width: "auto" }}
                      >
                        Office
                      </th>
                      {localStorage.getItem(SessionKeys.IS_IMPERSONATED) ===
                      "true" ? (
                        ""
                      ) : (
                        <th
                          className={`cursor-pointer`}
                          style={{ width: "auto" }}
                        >
                          Impersonate
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {myTeamsList?.map((item, index) => {
                      return (
                        <tr className="addBGcustomw">
                          <td
                            className="name-link cursor-pointer"
                            onClick={() => {
                              navigate(
                                "/profile/edit?section=edit&user_id=" +
                                  item.id +
                                  "&tab=1"
                              );
                            }}
                          >
                            {item.first_name + " " + item.last_name}
                          </td>
                          <td className="itmeeeamil">{item.email}</td>
                          <td className="otemrole">{item.Role}</td>
                          <td className="officename">{item.office_name}</td>
                          {localStorage.getItem(SessionKeys.IS_IMPERSONATED) ===
                          "true" ? (
                            ""
                          ) : (
                            <td
                              className="text-center cursor-pointer"
                              onClick={() => callImpersonateAPI(item)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                fill="rgba(45,45,45,1)"
                              >
                                <path d="M11.9999 17C15.6623 17 18.8649 18.5751 20.607 20.9247L18.765 21.796C17.3473 20.1157 14.8473 19 11.9999 19C9.15248 19 6.65252 20.1157 5.23479 21.796L3.39355 20.9238C5.13576 18.5747 8.33796 17 11.9999 17ZM11.9999 2C14.7613 2 16.9999 4.23858 16.9999 7V10C16.9999 12.6888 14.8776 14.8818 12.2168 14.9954L11.9999 15C9.23847 15 6.9999 12.7614 6.9999 10V7C6.9999 4.31125 9.1222 2.11818 11.783 2.00462L11.9999 2ZM11.9999 4C10.4022 4 9.09623 5.24892 9.00499 6.82373L8.9999 7V10C8.9999 11.6569 10.343 13 11.9999 13C13.5976 13 14.9036 11.7511 14.9948 10.1763L14.9999 10V7C14.9999 5.34315 13.6567 4 11.9999 4Z"></path>
                              </svg>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <div className="not-found cart-notfound">
                  <div className="interboxes">
                    <img src="/images/telescope.svg" alt="Not Found" />
                    <p>Currently, there is no team list available.</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  let is_impersonated = localStorage.getItem(SessionKeys.IS_IMPERSONATED);

  useEffect(() => {
    if (localStorage.getItem(SessionKeys.IS_IMPERSONATED) === "false") {
      getMyTeamsList();
    }
  }, [localStorage.getItem(SessionKeys.IS_IMPERSONATED)]);

  const renderContent = () => {
    return (
      <>
        <section className="my-credit-points learningpaths">
          <div className="container">
            <div className="row ">
              <div className="col-md-12">
                <div className="search_heading">
                  <p className="lable-heading_search">My Team List</p>
                </div>
                <div className="d-flex justify-content-end">
                  <div className="confirm-row m-0">
                    <input
                      type="search"
                      id="search"
                      name="search"
                      className="form-control"
                      autocomplete="off"
                      value={searchValue}
                      onChange={(evt) => {
                        setSearchValue(evt.target.value);
                      }}
                    />
                    <button className="confirm-btn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M9.16667 1.66669C5.02454 1.66669 1.66667 5.02455 1.66667 9.16669C1.66667 13.3088 5.02454 16.6667 9.16667 16.6667C10.9375 16.6667 12.565 16.053 13.8481 15.0266L16.9107 18.0893C17.2362 18.4147 17.7638 18.4147 18.0893 18.0893C18.4147 17.7638 18.4147 17.2362 18.0893 16.9108L15.0266 13.8481C16.0529 12.565 16.6667 10.9375 16.6667 9.16669C16.6667 5.02455 13.3088 1.66669 9.16667 1.66669ZM3.33334 9.16669C3.33334 5.94503 5.94501 3.33335 9.16667 3.33335C12.3883 3.33335 15 5.94503 15 9.16669C15 12.3883 12.3883 15 9.16667 15C5.94501 15 3.33334 12.3883 3.33334 9.16669Z"
                          fill="black"
                        ></path>
                      </svg>
                      Search
                    </button>
                  </div>
                </div>
                {/* <div className="input-lear position-relative d-flex mt-5 align-items-center">
              <label htmlFor="search" className="input__label_learning">
                Search
              </label>
              <input
                type="search"
                id="search"
                name="search"
                className="input_searchfield_search mb-0"
                autocomplete="off"
                value={searchValue}
                onChange={(evt) => {
                  setSearchValue(evt.target.value);
                }}
              />
              <button className="button-reset">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                 
                  id="Find"
                  width="28"
                  height="28"
                  viewBox="0 0 30 30"
                >
                  <defs>
                    <linearGradient
                      id="linear-gradient"
                      y1="0.5"
                      x2="1"
                      y2="0.5"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0" stopColor="#00b7f1"></stop>
                      <stop offset="1" stopColor="#ed156e"></stop>
                    </linearGradient>
                  </defs>
                  <circle
                    id="Ellipse_191"
                    data-name="Ellipse 191"
                    cx="15"
                    cy="15"
                    r="15"
                    fill="url(#linear-gradient)"
                  ></circle>
                  <circle
                    id="Ellipse_192"
                    data-name="Ellipse 192"
                    cx="13"
                    cy="13"
                    r="13"
                    transform="translate(2 2)"
                    fill="#fff"
                  ></circle>
                  <path
                    id="Icon_awesome-search"
                    data-name="Icon awesome-search"
                    d="M14.372,12.6,11.535,9.762a.683.683,0,0,0-.484-.2h-.464a5.917,5.917,0,1,0-1.025,1.025v.464a.683.683,0,0,0,.2.484L12.6,14.372a.68.68,0,0,0,.965,0l.805-.805A.686.686,0,0,0,14.372,12.6ZM5.92,9.562A3.643,3.643,0,1,1,9.562,5.92,3.641,3.641,0,0,1,5.92,9.562Z"
                    transform="translate(7.715 7.714)"
                    fill="#774d9f"
                  ></path>
                </svg>
              </button>
            </div> */}
                {/* <div className="input-text">
                                <label htmlFor="search" className="input__label">
                                    Search
                                </label>
                                <input
                                    type="search"
                                    id="search"
                                    name="search"
                                    className="input_field mr-2"
                                    placeholder=" "
                                    value={searchValue}
                                    onChange={(evt) => {
                                        setSearchValue(evt.target.value);
                                    }}
                                />
                            </div> */}
              </div>

              <div className=" my_learningpath_tab mt-1">
                {renderTableReport()}
              </div>
            </div>
          </div>
        </section>
        <ConfirmModal
          confirmModal={confirmModal}
          setConfirmModal={setConfirmModal}
          showModalMsg={showModalMsg}
          isConfirm={isConfirm}
          confirmAction={confirmAction}
          isRightIcon={false}
        />
      </>
    );
  };

  return (
    <>
      <Loader start={isLoading} />
      {isMobile === "true" ? renderContent() : <Page>{renderContent()}</Page>}
    </>
  );
};
export default MyTeamListPage;
